<script setup>
/* eslint-disable */
import { ref } from 'vue'
import { useGameStore } from '@/store/game'

const emit = defineEmits(['close'])
const showConfirmation = ref(false)
const gameStore = useGameStore()

const saveGame = () => {
  gameStore.saveGame()
  emit('close')
}

const confirmDeleteSave = () => {
  showConfirmation.value = true
}

const deleteSave = () => {
  localStorage.removeItem('chocobo-manager-save')
  window.location.reload()
}

const cancelDelete = () => {
  showConfirmation.value = false
}

const formatDate = (dateString) => {
  const date = new Date(dateString)
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  }).format(date)
}

const lastSaveTime = ref(null)
try {
  const savedGame = localStorage.getItem('chocobo-manager-save')
  if (savedGame) {
    lastSaveTime.value = formatDate(new Date())
  }
} catch (error) {
  console.error('Error getting save time:', error)
}
</script>

<template>
  <div class="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
    <div class="bg-white rounded-lg max-w-md w-full max-h-[90vh] overflow-hidden flex flex-col">
      <div class="p-6 overflow-y-auto flex-1">
      <div class="flex justify-between items-center mb-6">
        <h2 class="text-xl font-bold">Save Management</h2>
        <button 
          @click="$emit('close')"
          class="text-gray-500 hover:text-gray-700"
        >
          ✕
        </button>
      </div>

      <!-- Save Info -->
      <div class="mb-6">
        <div class="bg-gray-50 rounded-lg p-4">
          <div class="text-sm text-gray-600">Last Save:</div>
          <div class="font-medium">
            {{ lastSaveTime || 'No save data' }}
          </div>
        </div>
      </div>

      <!-- Actions -->
      <div class="space-y-4">
        <button 
          @click="saveGame"
          class="w-full px-4 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600"
        >
          Save Game
        </button>

        <button 
          @click="confirmDeleteSave"
          class="w-full px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600"
        >
          Delete Save Data
        </button>
      </div>

      <!-- Delete Confirmation Modal -->
      <div v-if="showConfirmation" class="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
        <div class="bg-white rounded-lg p-6 max-w-md w-full mx-4">
          <h3 class="text-lg font-bold mb-4">Delete Save Data?</h3>
          <p class="text-gray-600 mb-6">
            This will permanently delete your save data and return you to the title screen. This cannot be undone.
          </p>
          <div class="flex justify-end space-x-4">
            <button 
              @click="cancelDelete"
              class="px-4 py-2 border rounded-lg hover:bg-gray-50"
            >
              Cancel
            </button>
            <button 
              @click="deleteSave"
              class="px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600"
            >
              Delete Save
            </button>
          </div>
        </div>
      </div>
      </div>
    </div>
  </div>
</template>